import { render, staticRenderFns } from "./AssignAdminsModal.vue?vue&type=template&id=3d0d103a&scoped=true&"
import script from "./AssignAdminsModal.vue?vue&type=script&lang=js&"
export * from "./AssignAdminsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0d103a",
  null
  
)

export default component.exports